import { getFormatE164, getFormatNational } from '../utils/normalize-phone';

export const RENAULT_ID = 10301 as const;

export class Account {
  public administrator: boolean;
  public company: string;
  public instance: string;
  public supervisor: boolean;
  public t: string;
  public uid: number;
  public uid_company: number;
  public user_mail: string;
  public pretoken: string;
  public account_type: number;
  public password_force_change: boolean;
  public phone: string;
  public uid_site: number;
  public firstname: string;
  public lastname: string;
  public connect_link: string;
  public vmax_forbidden: boolean;
  public uid_news: number;
  public eco: number | boolean;
  public traffic: boolean;
  public enum_ongl_inter_sum: string;
  public enum_ongl_inter_modif_sum: string;
  public mission_access: boolean;
  public spatial_analysis_access: boolean;
  public allow_draft_delete: boolean;
  public month_max_exploitation: number;
  public max_trip_period: string;
  public id_conversation_user: number;
  public conversation_access: boolean;
  public broker_connection: boolean;
  public form_option: boolean;
  public maintenance_option: boolean;
  public report_option: boolean;
  public report_quota: number;
  public sms: boolean;
  public privacy_blur_radius: number;
  public fuel_option: boolean;
  public sms_quota: string;
  public edit_password: boolean;

  constructor(data: Partial<Account> = {}) {
    Object.assign(this, data);
    this.month_max_exploitation = data.supervisor ? 12 : (data.month_max_exploitation ?? 0);
  }

  get isSubsEco(): boolean {
    return this.eco === 1 || this.eco === true;
  }

  public get phoneNational(): string | null {
    return getFormatNational(this.phone);
  }

  public get phoneE164() {
    return getFormatE164(this.phone);
  }

  get isDisplaySpeed() {
    return !this.vmax_forbidden;
  }
}
